module.exports = __webpack_public_path__ + "img/mp-advantage-4.da15933e.png";